export enum INSPECTION_KINDS {
    DEPARTURE = "K575TI8OPE-DEP",
    BACK = "K575TI8OPE-ARR",
    INTERMEDIATE = "K575TI8OPE-ETA",
    CANCELED = "ZZ"
}
